export const carePaymentFrag = `
    id
    activeFrom
    activeTo
`;
